import { useSelector } from 'react-redux';
import { canManageReleaseNotes } from '../release-notes/release-note-model';

// Thisway Admin (role 100) or the releasenote-admin permission (spec §2).
const useCanManageReleaseNotes = () => {
  const roles = useSelector((state) => state.authReducer.roles);
  const rolepermissions = useSelector((state) => state.authReducer.rolepermissions);
  return canManageReleaseNotes(roles, rolepermissions);
};

export default useCanManageReleaseNotes;
